import { endpoints } from '../endpoints';
import { ThunkAction } from '../_commons/thunks.common';
import { Api } from '../_commons/http';
import { JobOfferApplicationActions } from './jobOfferApplication.actions';
import { QuestionnaireAnswer, QuestionnaireAnswersDto } from '../jobOffers/jobOffers.dto';

export class JobOfferApplicationThunks {
    static saveStaticQuestionsAnswers = (
        firstName: string,
        lastName: string,
        prefix: string,
        phoneNumber: string,
        email: string
    ): ThunkAction => async dispatch => {
        dispatch(
            JobOfferApplicationActions.saveStaticQuestionsAnswers(firstName, lastName, prefix, phoneNumber, email)
        );
    };

    static saveAdditionalAnswers = (additionalAnswers: QuestionnaireAnswer[]): ThunkAction => async dispatch => {
        dispatch(JobOfferApplicationActions.saveAdditionalAnswers(additionalAnswers));
    };

    static submitApplication = (): ThunkAction => async (dispatch, getState): Promise<boolean> => {
        dispatch(JobOfferApplicationActions.submitApplicationStarted());

        const jobOfferId = getState().jobOffers.list[0];
        const jobOffer = getState().jobOffers.items[jobOfferId];

        const postData: SubmitJobApplicationCommand = {
            jobOfferIdentifier: jobOfferId,
            jobOfferVersionId: jobOffer.jobOfferVersionId,
            questionnaireAnswersDto: {
                ...getState().jobOfferApplication.answers
            },
            referer: document.referrer
        };

        const { data, status, error } = await Api.post<SubmitJobApplicationCommandResponse>(
            `${endpoints.jobOffers}`,
            postData
        );

        if (status === 200) {
            dispatch(JobOfferApplicationActions.submitApplicationFinished());
            return true;
        } else if (status === 400) {
            dispatch(JobOfferApplicationActions.submitApplicationFailed(data as SubmitJobApplicationCommandResponse));
            return false;
        } else {
            dispatch(JobOfferApplicationActions.submitApplicationFailed(error as string));
            return false;
        }
    };
}

interface SubmitJobApplicationCommand {
    jobOfferIdentifier: string;
    jobOfferVersionId: string;
    referer: string;
    questionnaireAnswersDto: QuestionnaireAnswersDto;
}

export interface SubmitJobApplicationCommandResponse {
    errors: SubmitJobApplicationCommandError[];
}

export interface SubmitJobApplicationCommandError {
    errorType: string;
    causedBy: string;
    errorMessage: string;
}
